import { render } from "./TagsView.vue?vue&type=template&id=c4ce9eb8&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=c4ce9eb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ce9eb8"]])

export default __exports__